// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"48Obc":[function(require,module,exports) {
var _general = require("./general");
function getBrandFromUrl() {
    const path = window.location.pathname.replace(/^\/+/, ""); // Removes leading '/'
    const brand = path.replace("-mai", ""); // Removes '-mai' if it exists
    const formattedBrand = brand.includes("filippa") ? "Filippa K" : brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase();
    return formattedBrand;
}
const brand = getBrandFromUrl();
const isBrandLook2 = [
    "Filippa K",
    "Flattered"
].includes(brand) ? true : false;
function loadRecentlySold() {
    const recentlySoldItems = callBackendApi(`/api/items/recentlySold?brand=${brand}`);
    recentlySoldItems.then((result)=>{
        // Read result of the Cloud Function.
        const itemListRecentlySoldStartPage = document.getElementById("itemListRecentlySoldStartPage");
        itemListRecentlySoldStartPage.innerHTML = "";
        itemListRecentlySoldStartPageDesktop.innerHTML = "";
        console.log("Items fetched: ", result.data.length);
        let itemsDisplayed = 0;
        for (const item of result.data){
            if (isBrandLook2 && !item.frontImageOkForPublish) continue;
            const brand = item.brand;
            const cardSubtitle = item.brand;
            let cardTitle = item.category;
            if (item.cleanedModel) cardTitle = `${item.cleanedModel}${item.category && brand === "Filippa K" ? `, ${item.category}` : ""}`;
            const soldPrice = item.soldPrice;
            const soldDate = new Date(item.soldDate);
            const publishedDate = new Date(item.publishedDate);
            const soldTimeText = new Date(item.soldDate).toISOString().split("T")[0] === new Date().toISOString().split("T")[0] ? "Idag" : "Ig\xe5r";
            const imageUrl = (0, _general.itemCoverImage)(item);
            const daysToSold = Math.floor((soldDate.getTime() - publishedDate.getTime()) / 86400000);
            if (soldPrice >= 180 || daysToSold <= 20) {
                let itemCardHTML = `<div class="div-block-14-big"><div class="ratio-box _16-9"><div class="content-block with-image">
                        <div class="img-container" style="background-image: url('${imageUrl}');"></div></div></div>
                        <div class="text-block-14">${soldPrice} kr</div>
                        <div class='text-block-34'>${brand}</div>`;
                if (isBrandLook2) itemCardHTML = `<div class="div-block-14-${brand === "Filippa K" ? "super-" : ""}big"><div class="ratio-box _16-9"><div class="content-block with-image">
                        <div class="img-container" style="background-image: url('${imageUrl}');">
                        <div class="sold-tag">Sold</div></div></div></div>
                        <div class="text-block-14">${soldPrice} kr</div>
                        <div class='text-block-34'>${cardTitle}</div>
                        <div class='text-block-34'>${cardSubtitle}</div>`;
                //I cut out the "Idag / Igår" during summer, since so little is sold every day. Add this last to show it again: <div class='text-block-34'>${soldTimeText}</div></div>
                itemListRecentlySoldStartPage.innerHTML += itemCardHTML;
                const desktopCardHTML = itemCardHTML.replace("14-big", "14-big-desktop").replace("14-super-big", "14-big-desktop");
                itemListRecentlySoldStartPageDesktop.innerHTML += desktopCardHTML;
                itemsDisplayed++;
            }
        }
        if (isBrandLook2) itemListRecentlySoldStartPage.innerHTML += `<div class="div-block-14-super-big"><div class="ratio-box _16-9"><div class="content-block with-image">
                        <a href="https://shop.maiapp.se/collections${brandPartners[brand].maiShopPath}" class="see-more-items-button">Till Mai Shop</a>  
                        </div></div>`;
    }).catch((error)=>{
        errorHandler.report(error);
        // Getting the Error details.
        var code = error.code;
        var message = error.message;
        console.log("Error message: ", message, code);
    });
// [END fb_functions_call_add_message_error]
}
async function fetchAndLoadRecentlyAddedItems() {
    try {
        console.log("brand", brand);
        const response = await callBackendApi(`/api/shopify/recentlyAddedItems?brand=${brand}`);
        const itemList = document.getElementById("ItemListRecentlyAddedItems");
        const itemListDesktop = document.getElementById("ItemListRecentlyAddedItemsDesktop");
        itemList.innerHTML = "";
        itemListDesktop.innerHTML = "";
        console.log("response.data[0]", response.data[0]);
        for (const item of response.data){
            let itemCardHTML = `<div class="div-block-14-big"><a href="${item.url}"/><div class="ratio-box _16-9"><div class="conten-block with-image">
                        <div class="img-container" style="background-image: url('${item.image}')"></div></div></div>
                        <div class="recently-added-text-block">
                            <div class="recent-added-items-subheader">${item.brand}</div>
                            <div class="recent-added-items-subheader-category">${item.category}</div>
                            <div class="recently-added-price">${item.currentPrice} kr</div>
                        </div><a/></div>`;
            if (isBrandLook2) itemCardHTML = `<div class="div-block-14-super-big"><a href="${item.url}"/><div class="ratio-box _16-9"><div class="conten-block with-image">
                        <div class="img-container" style="background-image: url('${item.image}')"></div></div></div>
                        <div class="recently-added-text-block">
                            <div class="text-block-14">${item.brand}</div>
                            <div class='text-block-34'>${item.category}</div>
                            <div class='text-block-34'>${item.currentPrice} kr</div>
                        </div><a/></div>`;
            itemList.innerHTML += itemCardHTML;
            const desktopCardHTML = itemCardHTML.replace("14-big", "14-big-desktop").replace("14-super-big", "14-big-desktop");
            itemListDesktop.innerHTML += desktopCardHTML;
        }
        if (isBrandLook2) itemList.innerHTML += `<div class="div-block-14-super-big"><div class="ratio-box _16-9"><div class="content-block with-image">
                        <a href="https://shop.maiapp.se/collections/${brandPartners[brand].maiShopPath}" class="see-more-items-button">Upptäck mer</a>  
                        </div></div>`;
    } catch (e) {
        errorHandler.report(e);
        console.log("error", e);
    }
}
// Channel bottom sheet
const openIds = [
    "sellItemCtaButton",
    "sellWithMaiCarouselButton",
    "sellStickyHeaderButton"
];
openIds.forEach((id)=>{
    const button = document.getElementById(id);
    if (button) button.addEventListener("click", ()=>(0, _general.channelRouter)("/sell-item"));
});
const closeIds = [
    "darkOverlay",
    "closeChannelBottomSheet"
];
closeIds.forEach((id)=>{
    const element = document.getElementById(id);
    if (element) element.addEventListener("click", ()=>(0, _general.hideChannelBottomSheet)());
});
// End of channel bottom sheet
loadRecentlySold();
fetchAndLoadRecentlyAddedItems();
// Set attribution cookies (could be put on any campaign page)
checkCookie("utm_campaign");
checkCookie("utm_source");
checkCookie("utm_medium");
checkCookie("utm_term");
checkCookie("utm_content");
// Set invite code cookie
const inviteCode = checkCookie("invite");
if (inviteCode) {
    referralCodeText.innerHTML = inviteCode;
    activeCode.style.display = "flex";
}
if (!isBrandLook2) {
    window.intercomSettings = {
        app_id: "klyy0le5"
    };
    (function() {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            var d = document;
            var i = function() {
                i.c(arguments);
            };
            i.q = [];
            i.c = function(args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function() {
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = "https://widget.intercom.io/widget/klyy0le5";
                var x = d.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
            };
            if (w.attachEvent) w.attachEvent("onload", l);
            else w.addEventListener("load", l, false);
        }
    })();
}

},{"./general":"1tOWF"}],"1tOWF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signOut", ()=>signOut);
parcelHelpers.export(exports, "setFormAddressFields", ()=>setFormAddressFields);
parcelHelpers.export(exports, "getFormAddressFields", ()=>getFormAddressFields);
// Validate Swedish Social Security Number (personnummer) using checksum
//   Note: this is somewhat simplified because it does not take into account
//   that the date of the number is valid (e.g. "000000-0000" does return as true)
parcelHelpers.export(exports, "isValidSwedishSsn", ()=>isValidSwedishSsn);
parcelHelpers.export(exports, "formatPersonalId", ()=>formatPersonalId);
parcelHelpers.export(exports, "itemCoverImage", ()=>itemCoverImage);
parcelHelpers.export(exports, "shareCode", ()=>shareCode);
// Channel bottom sheet
parcelHelpers.export(exports, "channelRouter", ()=>channelRouter);
parcelHelpers.export(exports, "hideChannelBottomSheet", ()=>hideChannelBottomSheet) // End of channel bottom sheet
;
function signOut() {
    firebase.auth().signOut().then(()=>{
        console.log("User signed out");
        authUser.current = null;
        user.current = null;
        userId = null;
        localStorage.removeItem("sessionUser");
        localStorage.removeItem("idToken");
        localStorage.removeItem("authUserId");
        localStorage.removeItem("authUser");
        deleteCookie("maiAuth");
        location.href = "/";
    }).catch((error)=>{
        errorHandler.report(error);
        console.log(error);
    });
}
function setFormAddressFields(user1) {
    document.getElementById("addressFirstName").value = user1.addressFirstName || "";
    document.getElementById("addressFirstName").dispatchEvent(new Event("input"));
    document.getElementById("addressLastName").value = user1.addressLastName || "";
    document.getElementById("addressLastName").dispatchEvent(new Event("input"));
    document.getElementById("addressStreetAddress").value = user1.addressStreetAddress || "";
    document.getElementById("addressStreetAddress").dispatchEvent(new Event("input"));
    document.getElementById("addressCO").value = user1.addressCO || "";
    document.getElementById("addressCO").dispatchEvent(new Event("input"));
    document.getElementById("addressPostalCode").value = user1.addressPostalCode || "";
    document.getElementById("addressPostalCode").dispatchEvent(new Event("input"));
    document.getElementById("addressCity").value = user1.addressCity || "";
    document.getElementById("addressCity").dispatchEvent(new Event("input"));
    document.getElementById("addressDoorCode").value = user1.addressDoorCode || "";
    document.getElementById("addressDoorCode").dispatchEvent(new Event("input"));
}
function getFormAddressFields() {
    let addressFirstName = document.getElementById("addressFirstName").value;
    let addressLastName = document.getElementById("addressLastName").value;
    let addressStreetAddress = document.getElementById("addressStreetAddress").value;
    let addressCO = document.getElementById("addressCO").value;
    let addressPostalCode = document.getElementById("addressPostalCode").value;
    let addressCity = document.getElementById("addressCity").value;
    let addressDoorCode = document.getElementById("addressDoorCode").value;
    addressFirstName = addressFirstName ? addressFirstName.trim().charAt(0).toUpperCase() + addressFirstName.trim().slice(1) : "";
    addressLastName = addressLastName ? addressLastName.trim().charAt(0).toUpperCase() + addressLastName.trim().slice(1) : "";
    addressStreetAddress = addressStreetAddress ? addressStreetAddress.trim().charAt(0).toUpperCase() + addressStreetAddress.trim().slice(1) : "";
    addressCO = addressCO ? addressCO.trim() : "";
    addressPostalCode = addressPostalCode ? addressPostalCode.trim().replace(/\D/g, "") : "";
    addressCity = addressCity ? addressCity.trim().charAt(0).toUpperCase() + addressCity.trim().slice(1) : "";
    addressDoorCode = addressDoorCode ? addressDoorCode.trim() : "";
    return {
        addressFirstName,
        addressLastName,
        addressStreetAddress,
        addressCO,
        addressPostalCode,
        addressCity,
        addressDoorCode
    };
}
function isValidSwedishSsn(ssn) {
    ssn = ssn.replace(/\D/g, "") // strip out all but digits
    .split("") // convert string to array
    .reverse() // reverse order for Luhn
    .slice(0, 10); // keep only 10 digits (i.e. 1977 becomes 77)
    // verify we got 10 digits, otherwise it is invalid
    if (ssn.length !== 10) return false;
    const sum = ssn.map((n)=>Number(n)).reduce((previous, current, index)=>{
        if (index % 2) current *= 2;
        if (current > 9) current -= 9;
        return previous + current;
    });
    return 0 === sum % 10;
}
function formatPersonalId(personalIdInput) {
    let personalId = personalIdInput.replace("-", "");
    if (personalId.length !== 12 && (personalId.substring(0, 2) !== "19" || personalId.substring(0, 2) !== "20")) {
        if (Number(personalId.substring(0, 2)) <= 99 && Number(personalId.substring(0, 2)) > 25) personalId = "19" + personalId;
        else personalId = "20" + personalId;
    }
    if (personalId.length === 12) return personalId;
    return null;
}
function itemCoverImage(item) {
    if (item.images) {
        const images = item.images;
        return images.modelImageSmall || images.modelImage || images.coverImageSmall || images.coverImage || images.enhancedFrontImageSmall || images.enhancedFrontImage || images.frontImageSmall || images.frontImage;
    } else if (item.imagesv2) {
        const priorityOrder = [
            "modelImage",
            "enhancedFrontImage",
            "frontImage"
        ];
        for (const name of priorityOrder){
            const image = item.imagesv2.find((img)=>img.name === name);
            if (image) {
                if (image.versions.small) return image.versions.small;
                if (image.versions.medium) return image.versions.medium;
                if (image.versions.large) return image.versions.large;
                if (image.url) return image.url;
            }
        }
    }
    return null;
}
function shareCode() {
    const code = user.current.referralData.referralCode;
    //const text = `Hej, jag vill tipsa om Mai för att rensa ur garderoben. Mai är en tjänst som hjälper dig att sälja dina kläder på ett enkelt sätt. Man tar bara bilder på sina plagg, sedan sköter Mai resten - såsom värdering, annonsering på flera plattformar, kontakt med köpare och frakt när det blir sålt. Man får själv behålla 80% av vinsten, och blir det inte sålt kostar det ingenting.\n\nOm du registrerar dig med min kod (följ länken) och provar sälja ett plagg inom 7 dagar får du behålla 100% av vinsten för det första plagget (istället för 80%). Min kod: ${code}\n\nLäs mer och använd min kod här:`;
    const text = `Hej! Följ min personliga länk så säljer Mai ditt första plagg kostnadsfritt! Mai sköter försäljningen av dina kläder, inklusive värdering, lägger ut på flera plattformar samtidigt, har kontakten med köpare och ordnar med frakt när det blir sålt. Man får själv behålla 80% av vinsten, och blir det inte sålt kostar det ingenting.\n\nOm du registrerar dig med min kod (följ länken) och provar sälja ett plagg inom 7 dagar får du behålla 100% av vinsten för det första plagget (istället för 80%). Min kod: ${code}`;
    if (navigator.share) navigator.share({
        text: text,
        url: `https://invite.maiapp.se/refer?invite=${code}`
    }).then(()=>{
        console.log("Thanks for sharing!");
    }).catch((e)=>{
        console.error(e);
        errorHandler.report(e);
    });
    else {
        console.log("Browser doesn't support navigator.share => Copy to clipboard!");
        const shareText = text + "\n" + `https://invite.maiapp.se/refer?invite=${code}`;
        navigator.clipboard.writeText(shareText);
        linkCopiedBanner.style.display = "flex";
        setTimeout(function() {
            linkCopiedBanner.style.display = "none";
        }, 1500);
    }
}
function channelRouter(webpath) {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) showChannelBottomSheet(webpath);
    else window.location.href = webpath;
}
function showChannelBottomSheet(webpath) {
    document.getElementById("continueOnWebBottomSheet").href = window.location.origin + webpath;
    document.getElementById("darkOverlay").classList.add("active");
    document.getElementById("channelBottomSheet").classList.add("active");
}
function hideChannelBottomSheet() {
    document.getElementById("darkOverlay").classList.remove("active");
    document.getElementById("channelBottomSheet").classList.remove("active");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bNgzC":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["48Obc"], "48Obc", "parcelRequire81ca")

//# sourceMappingURL=brand.js.map
